import { render, staticRenderFns } from "./CorrelationOrderDrawer.vue?vue&type=template&id=7a8c9513&scoped=true"
import script from "./CorrelationOrderDrawer.vue?vue&type=script&lang=ts"
export * from "./CorrelationOrderDrawer.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationOrderDrawer.vue?vue&type=style&index=0&id=7a8c9513&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8c9513",
  null
  
)

export default component.exports